/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This component is a wrapper around the notifications system.
 *
 * See http://vue-notification.yev.io/ for more informations
 *
 * @category ui.components
 * @exports Noty
 * @component
 */
const __vue_script__ = {
    name: 'Noty',

    props: {
        width: {
            type: Number,
            default: 320
        }
    },

    methods: {
        /**
         * Toggles the close function
         *
         * @param {Function} close the closing function provided by vue notification
         * @param {object} item the notification item
         */
        dismiss(close, item) {
            close();
            const cb = item?.data?.closed;

            if (typeof cb === 'function') {
                cb();
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("notifications", {
    staticClass: "flashes",
    attrs: {
      group: "flashes",
      classes: "flash",
      position: "bottom right",
      width: _vm.width,
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function (ref) {
          var item = ref.item
          var close = ref.close
          return [
            _c(
              "div",
              {
                staticClass: "vue-notification",
                class: item.type || "success",
              },
              [
                _c("span", {
                  staticClass: "close",
                  on: {
                    click: function ($event) {
                      return _vm.dismiss(close, item)
                    },
                  },
                }),
                _c("i", { staticClass: "ic-noty" }),
                item.title
                  ? _c("p", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.title)),
                    ])
                  : _vm._e(),
                _c("div", {
                  staticClass: "message",
                  domProps: { innerHTML: _vm._s(item.text) },
                }),
                item.data
                  ? _c("div", { staticClass: "button-group actions" }, [
                      item.data.button
                        ? _c(
                            "button",
                            {
                              staticClass: "btn confirm",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return item.data.action(_vm.props)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.data.button))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/Noty.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__